/*
 * @Author: your name
 * @Date: 2021-02-21 22:03:08
 * @LastEditTime: 2021-10-10 00:09:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /red_packet_admin/src/api/modules/user.js
 */
import request from "../request";

// 保单查询接口
export function getRemoteInfo(data) {
  return request({
    url: "/user/getRemoteInfo",
    method: "post",
    data,
  });
}
